import { getTrackBackground, Range } from "react-range";
import React, { useState } from "react";
import useDeviceType from "../../utils/useDeviceType";
import clsx from "clsx";

export const RangeInput = ({ trackClass, thumbClass, value, onChange, min = 0, max = 100, step = 0.1 }) => {

    const [showTooltip, setShowTooltip] = useState(false);
    const { isMobileView } = useDeviceType()
    const marks = [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]

    return (
        <div className="relative">
            <Range
                step={step}
                min={min}
                max={max}
                values={[value]}
                onChange={(values) => onChange(values[0])}
                renderTrack={({ props, children }) => (
                    <div
                        {...props}
                        className={clsx("bg-neutral-200 rounded h-1.5 mx-1.5", trackClass)}
                        style={{
                            background: getTrackBackground({
                                values: [value],
                                colors: ['#0046F6', '#0046F614'],
                                min: min,
                                max: max,
                            }),
                        }}
                    >
                        {children}
                    </div>
                )}
                renderThumb={({ props }) => (
                    <div
                        onMouseEnter={() => !isMobileView ? setShowTooltip(true) : null}
                        onMouseLeave={() => !isMobileView ? setShowTooltip(false) : null}
                        onTouchStart={() => isMobileView ? setShowTooltip(true) : null}
                        onTouchEnd={() => isMobileView ? setShowTooltip(false) : null}
                        {...props}
                        className={clsx("bg-white border border-accumin-primary-electric-blue rounded-2xl h-[18px] w-[18px] focus:outline-none",
                            thumbClass)}
                    >
                        {showTooltip &&
                            <>
                                <div className="absolute bottom-7 rotate-45 left-1/3 bg-accumin-primary-electric-blue h-2 w-2" />
                                <div
                                    className="absolute bottom-[30px] -left-[15px] text-sm bg-accumin-primary-electric-blue rounded-md py-1.5 w-12 text-center text-white"
                                >
                                    {value.toFixed(1).replace('.', ',')}
                                </div>
                            </>
                        }

                    </div>
                )} />
            <div className="flex justify-between px-2 mt-2">
                {marks.map((mark) => (
                    <div key={mark} className="flex flex-col items-center">
                        <div className="h-1 w-px bg-accumin-neutral-300 rounded-sm mb-1" />
                        {Number.isInteger(mark) && (
                            <div className="text-xs text-accumin-neutral-300">
                                {mark}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
